export default class Amount {
    currency: string = '';
    amount: string = '0.00';
}
